<template>
<div class="shopStoreTel">
  <div class="shopStoreTel__main">
    <div class="shopStoreTel__mainTitleWrap">
      <h4 class="shopStoreTel__mainTitle"><span>20</span><span>名以上</span><span>の宴会</span><br class="pcOnly">のご相談はこちらへ！</h4>
    </div>
    <div class="shopStoreTel__mainTelWrap">
      <div class="shopStoreTel__mainTelWrapInner">
        <tel-link v-if="twilioTel" :value="twilioTel" class="shopStoreTel__num">
          <i class="phone icon spOnly"></i>{{ twilioTel}}
        </tel-link>
        <tel-link v-else :value="conciergeTel" class="shopStoreTel__num">
          <i class="phone icon spOnly"></i>{{ conciergeTel }}
        </tel-link>
        <p>※こちらは20名以上～大人数のご宴会専用ダイヤルです</p>
      </div>
    </div>
  </div>
  <div class="shopStoreTel__sub">
    <div class="shopStoreTel__subTextWrap">
      <p><span>20名未満、人数変更・その他の<br class="pcOnly">お問い合わせ</span>はこちら</p>
    </div>
    <div class="shopStoreTel__subLinkWrap">
      <tel-link :value="shopTel"></tel-link>
    </div>
  </div>
</div>
</template>

<script>
export default {
    props: {
        shopId: {
            required: true,
            type: String
        },
        shopName: {
            required: true,
            type: String
        },
        shopTel: {
            required: true,
            type: String
        },
        twilioTel: {
            required: true,
            type: String
        },
        linkClass: {
            required: false,
            type: String
        }
    },
    methods: {
        openDialog: function() {
            $('#show-shop-tel-dialog').modal('show');
        },
    }
};
</script>
